/*
 * @TagTable.vue
 * @Description 工时统计
 * @Author 
 * @Date 
 */
<template>
	<div class="table-item-box _padding-l-none" style="padding: 10px;">
		<section style="height: 100%;" >
			<div v-if="false" >以柱状图按年/月展示每月/日施工人员总数，总工时</div>
			
			<!-- 主内容 start -->
			<div style="height: calc(100% - 85px);margin-bottom: 20px;">
				<div v-if="$checkEmpty(dataList)" class="none-map-item"><img alt="暂无数据" title="暂无数据" src="@/static_dazzle/images/data_none.png" ></div>
				
				<div v-show="!$checkEmpty(dataList)" v-resize="elDomResize" id="statistic_approach" style="height: 100%; width: 100%;"></div>
			</div>
			<!-- 主内容 end -->
			
			<!-- 查询工具条 start -->
			<el-col >
				<el-form :inline="true" :model="filters" ref="filters" >
					<el-form-item>查询条件：</el-form-item>
					<el-select v-model="filters.year" style="width: 200px;margin-right: 10px;" @change="getMonths()">
						<el-option v-for="(value, key) in years" :key="key" :label="value" :value="key"></el-option>
					</el-select>
					<el-select v-model="filters.month" style="width: 200px;margin-right: 10px;" placeholder="所有月份" clearable @change="search();">
						<el-option v-for="(value, key) in months" :key="key" :label="value" :value="key"></el-option>
					</el-select>
					<el-select v-model="filters.typeId" style="width: 200px;margin-right: 10px;" placeholder="所有人员类型" clearable @change="handleType">
						<el-option v-for="(item, index) in userTypes" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
					<el-autocomplete
						:style="{width:'300px'}"
						ref="elautocomplete"
						class="inline-input"
						v-model="filters.keyword"
						:fetch-suggestions="querySearch"
						:placeholder="filters.placeholderOpt[filters.bindingType]"
						:trigger-on-focus="false"
						clearable
						@clear="handleClear"
						@select="handleSelect"
						@keyup="changeStyle('block', '.el-autocomplete-suggestion')"
						>
						<i slot="suffix" class="el-input__icon el-icon-search" @click="search()"></i>
					</el-autocomplete>
				</el-form>
			</el-col>
			<!-- 查询工具条 end -->
			
		</section>
		
	</div>
	
</template>

<script>
	// 基站组件
	import ApiApproach from '@/request/api-approach'
	import Pagination from '@/components/Pagination'
	// API 人员信息
	import ApiUser from '@/request/api-user'
	
	export default {
		name: "ApproachStatistics",
		/**
		 * @Des 组件引用
		 * @Auth 
		 * @Date 
		 * */
		components: {
			Pagination
		},
		
		props:{
			userTypes: Array,
		},// props
		
		/**
		 * @Des 数据定义
		 * @Auth 
		 * @Date 
		 * */
		data() {
			return {
				filters: {
					// 年
					year: 0,
					// 月
					month: 0,
					// 类型
					typeId:'',
					// 关键词
					keyword: '',
					// 绑定类型
					bindingType: 1,
					// placeholder
					placeholderOpt: {1: '请输入人员姓名/编号',2: '请输入车辆类型/车牌号'},
					// 查询
					queryString: '',
					// 查询的绑定id
					bindingId: '',
					// 绑定name
					bindingName: '',
					// 绑定 obj
					bindingObj: null,
				},
				users:[],
				years: [],
				months: [],
				// 统计数据
				dataList: [],
				
				// timer
				timer_checkDataInt: null,
			}// return
		},// data()
		computed: {
			
		},
		created(){
			this.getYearMonths();
		},
		mounted(){
			
		},
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			// 关闭 timer
        	this.endTimers();
		},// beforeDestroy
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 * */
		watch: {
			
		},
		/**
		 * @Des 方法定义
		 * @Auth 
		 * @Date 
		 * */
		methods: {
			/**
        	 * @Des 关闭 timer
        	 * @Auth
        	 * @Date
        	 */
        	endTimers() {
				// 清除计时器
				if (!this.$checkEmpty(this.timer_checkDataInt)) {
					clearInterval(this.timer_checkDataInt);
					this.timer_checkDataInt = null;
				}
        	},
			/**
			 * @Des dom 尺寸更改
			 * @Auth
			 * @Date 
			 */
			elDomResize(data) {
				// 清除定时器
				if (!this.$checkEmpty(this.timer_checkDataInt)) {
					// 清除定时器
					clearInterval(this.timer_checkDataInt);
				}
				
				if (!this.$checkEmpty(this.dataList)) {
					// 延迟执行
					this.$nextTick(() => {
						// 初始化 charts
						this.initCharts();
					});
				} else {
					// 定时器
					this.timer_checkDataInt = setInterval(() => {
						if (!this.$checkEmpty(this.dataList)) {
							// 清除定时器
							clearInterval(this.timer_checkDataInt);
							// 延迟执行
							this.$nextTick(() => {
								// 初始化 charts
								this.initCharts();
							});
						}
					}, 200);
				}
			},
			
			/**
			 * @Author 
			 * @Description //TODO 获取年
			 * @Date 
			 * @Param 
			 * @return 
			 * */
			getYearMonths: function () {
				this.years = Object.assign({}, {});
				let date = new Date();
				let year = date.getFullYear();
				for(let i=0;i<5;i++){
					let number = year - i;
					this.years[number] = number + '年';
				}
				let month = date.getMonth() + 1;
				this.getMonths();
				this.filters.year = year + '';
				this.filters.month = month + '';
			},
			/**
			 * @Author 
			 * @Description //TODO 获取月
			 * @Date 
			 * @Param 
			 * @return 
			 * */
			getMonths() {
				let date = new Date();
				let year = date.getFullYear();
				this.months = Object.assign({}, {});
				if(this.filters.year == year){
					let month = date.getMonth() + 1;
					for(let i=1;i<=month;i++){
						this.months[i] = i + '月'
					}
				}else{
					for(let i=1;i<=12;i++){
						this.months[i] = i + '月'
					}
				}
				
				// 当前月不存在
				if (!this.months.hasOwnProperty(this.filters.month)) {
					this.filters.month = '';
				}
				
				// 延迟执行
				this.$nextTick(() => {
					// 查询 进出人员工时统计
					this.search();
				});
			},
			/**
			 * @Des 查询 进出人员工时统计
			 * @Auth 
			 * @Date 
			 * */
			search() {
				this.$request.postJsonRequest(ApiApproach.searchUserTimeApi, {
					projectId: this.$store.state.currentProjectId,
					typeId: this.filters.typeId.replace("T", ""),
					userId: this.filters.bindingId,
					year: this.filters.year,
					month: this.filters.month,
				}).then(result => {
					// 统计数据
					this.dataList = !this.$checkEmpty(result.data) && !this.$checkEmpty(result.data.data) ? Object.assign([], result.data.data) : [];
					
					// 初始化 charts
					this.initCharts();
				}).catch(error => {
					console.error('查询进出人员工时统计异常', ApiApproach.searchInoutApi, error);
				})
			},
			
			/**
			 * @Des change 类型
			 * @Auth
			 * @Date
			 */
			handleType(item) {
				
				if (item != '' && this.filters.bindingObj) {
					let groupId = item.replace("T", "");
					// 清除选择
					groupId != this.filters.bindingObj.groupId && this.handleClear();
				}
				
				// 查询 进出人员工时统计
				this.search();
			},
			
			/**
			 * @Des 匹配建议
			 * @Auth
			 * @Date
			 */
			querySearch(queryString, callback) {
				if(queryString == ''){
					this.changeStyle('none', '.el-autocomplete-suggestion');
					return;
				}
				switch(this.filters.bindingType) {
					case 1:
						this.searchUser(callback);
					break;
					default : 
					break;
				}
			},
			/**
			 * @Des 选择建议
			 * @Auth
			 * @Date 
			 * */
			handleSelect(item) {
				if(item.id == '0'){
					this.filters.bindingId = '';
					this.filters.keyword = '';
					this.filters.bindingName = '';
					this.filters.bindingObj = null;
					
					// 延迟执行
					this.$nextTick(() => {
						// 查询 进出人员工时统计
						this.search();
					});
					
					return false;
				}
				this.filters.bindingId = item.id;
				this.filters.bindingName = item.userName;
				this.filters.bindingObj = Object.assign({}, item);
				
				// 延迟执行
				this.$nextTick(() => {
					// 查询 进出人员工时统计
					this.search();
				});
			},
			/**
			 * @Des 清除选择
			 * @Auth
			 * @Date 
			 * */
			handleClear() {
				this.filters.bindingId = '';
				this.filters.keyword = '';
				this.filters.bindingName = '';
				this.filters.bindingObj = null;
				
				// 查询 进出人员工时统计
				this.search();
			},
			/**
			 * @Des 查询人员
			 * @Auth
			 * @Date 
			 * */
			searchUser(callback){
				this.$request.postJsonRequest(ApiUser.searchUserApi,{
					projectId: this.$store.state.currentProjectId,
					keyword: this.filters.keyword,
					groupId: this.filters.typeId.replace("T", ""),
					orderBy: {
						user_name: 'asc'
					}
				}).then(result => {
					// console.log(result)
					// 人员 list
					this.users = result.rows;
					result.rows.forEach((row, index) => {
						row.value = row.idCard + "：" + row.userName;
						row.id = row.userId;
					})
					if(this.users.length > 0){
						callback && callback(this.users);
					}else{
						callback && callback([{value: '未匹配到人员', id: '0'}]);
					}
				}).catch(error => {
					console.error('查询人员异常', ApiUser.searchUserApi, error);
				})
			},
			/**
			 * @Des 改变样式
			 * @Auth
			 * @Date 
			 * */
			changeStyle(status, className){
				let dom = document.querySelectorAll(className);
				dom[0].style.display = status;
			},
			
			// ======================================== 工时统计 chart start ========================================
			/**
			 * @Des 初始化 charts
			 * @Auth
			 * @Date 
			 */
			initCharts() {
				
				// dispose
				if (this.myChart) {
					this.myChart.dispose();
					this.myChart = null;
				};
				
				// 未展示 中止
				if (document.querySelector('#statistic_approach').offsetParent === null) return false;
				
				// myChart 工时统计
				this.myChart = this.$echarts.init(document.getElementById('statistic_approach'));
				// 初始化 chart 工时统计
				this.initChart();
				
			},// initCharts
			
			/**
			 * @Des 初始化 chart 工时统计
			 * @Auth
			 * @Date
			 */
			initChart_pie() {
				
				// 数据重组
				let dataList = Object.assign([], this.dataList);
				
				// 遍历 提取数据
				dataList.forEach((row, index) => {
					row.value = !this.$checkEmpty(row.val) ? row.val : 0;
				});
				
				let THIS = this;
				this.option = {
					darkMode: false,
					textStyle: {
						/*color: '#B9B8CE'*/
						color: '#fff'
					},
					title: {
						text: '',
						subtext: '',
						left: 'center',
						textStyle: {
							color: '#fff',
							fontSize: 18,
							fontWeight: 'bold'
						},
						subtextStyle: {
							color: '#fff',
							fontSize: 12
						}
					},
					tooltip: {
						trigger: 'item',
						textStyle: {
							align: 'justify'
						}
					},
					legend: {
						//orient: 'vertical',
						left: 'left',
						textStyle: {
							color: '#fff',
							lineHeight: 0,
							height: 0,
							rich:{
		                        a:{
		                            fontSize:14,
		                            align:'left',
		                            padding:[0,0,0,0],
		                            verticalAlign: 'middle'
		                        },
		                        b:{
		                            fontSize:18,
		                        	lineHeight: 40,
		                        	
		                            align:'center',
		                            padding:[10,0,0,0],
		                            fontWeight: 'bold'
		                        }
							}
						},
						icon:'circle',
						formatter: function (name) {
							let data = THIS.option.series[0].data
							// console.log(data, 'data')
							let total = 0
							let tarValue
							for (let i = 0; i < data.length; i++) {
								total += data[i].value
								if (data[i].name == name) {
									tarValue = data[i].value
								}
							};
							let v = tarValue + '人';
							//计算出百分比
							let p = Math.round((tarValue / total) * 100) + '%';
							
							return  '{a|'+ name +' }\n{b|'+ v +'}';
							//return `${name}  \n ${'<b>'+v+'</b>'}`;
							//name是名称，v是数值
						},
					},
					color: ['#ffcc43', '#ff4343', '#4375ff', '#4185f0', '#feb10d', '#08d5fb', '#05c091', '#58d9f9', '#4992ff', '#7cffb2', '#ff8a45', '#8d48e3', '#fddd60', '#dd79ff', '#ff6e76', ],
					series: [
						{
							name: '人员数量',
							type: 'pie',
							//radius: '60%',
							radius: ['50%', '60%'],
							data: dataList,
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.8)'
								}
							},
							label: {
								show: false
							},
							labelLine: {
								show: false
							}
						}
					]
				};
				// set option
				this.myChart.setOption(this.option);
			},// initChart_pie
			
			/**
			 * @Des 初始化 chart 工时统计
			 * @Auth
			 * @Date 
			 */
			initChart() {
				
				// 数据重组
				let dataList = Object.assign([], this.dataList);
				
				let nameList = [];
				let numList = [];
				let timeList = [];
				// 遍历 提取数据
				dataList.forEach((row, index) => {
					if (this.filters.month != '') {
						nameList.push(row.day + '日');
					} else {
						nameList.push(row.month + '月');
					}
					numList.push(row.number);
					timeList.push(row.time);
				});
				
				let subtext = [this.filters.year + '年'];
				if (this.filters.month != '') {
					subtext.push(this.filters.month + '月');
				}
				
				let groupName;// this.filters.typeId == '' ? '所有人员' : 
				if (this.filters.typeId != '') {
					Object.assign([], this.userTypes).forEach((row, index) => {
						if (!groupName && row.id == this.filters.typeId) {
							groupName = row.name;
						}
					});
				}
				
				subtext.push(this.filters.bindingName != '' ? this.filters.bindingName : (groupName ? groupName : '人员'));
				
				subtext.push('工时统计');
				
				let series = [];
				// 非具体人员
				if (this.filters.bindingName == '') {
					series.push({
						name: '人员数量',
						type: 'bar',
						label: {
							show: true,
							formatter: '{c}',
							position: 'top',
							color: '#fff'
						},
						itemStyle: {
							/*color: function (param) {
								let colorList = [
									'#91cc75', '#48bb11', '#48aa19', '#51dd0f', '#6fdb3b', '#60c230',
									'#98e274', '#8acc6a', '#74ac59', '#55e50f', '#4ac90c', '#42b10c',
								];
								return colorList[param.dataIndex] || 'red';
							}*/
						},
						data: numList
					});
				}
				series.push({
					name: '工时',
					type: 'bar',
					label: {
						show: true,
						formatter: '{c}',
						position: 'top',
						color: '#fff'
					},
					itemStyle: {
						/*color: function (param) {
							let colorList = [
								'#91cc75', '#48bb11', '#48aa19', '#51dd0f', '#6fdb3b', '#60c230',
								'#98e274', '#8acc6a', '#74ac59', '#55e50f', '#4ac90c', '#42b10c',
							];
							return colorList[param.dataIndex] || 'red';
						}*/
					},
					data: timeList
				});
				
				this.option = {
					darkMode: true,
					textStyle: {
						color: '#fff'
					},
					title: {
						text: '',
						subtext: subtext.join(''),
						textStyle: {
							color: '#B9B8CE',
							fontSize: 18,
							fontWeight: 'bold'
						},
						subtextStyle: {
							color: '#B9B8CE',
							fontSize: 16,
						},
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
						textStyle: {
							align: 'justify'
						}
					},
					legend: {
						show: this.filters.bindingName == '',
						left: 'right',
						textStyle: {
							color: '#ececec'
						}
					},
					grid: {
						top: '10%',
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					yAxis: {
						type: 'value',
						boundaryGap: [0, 0.01],
						minInterval: 1
					},
					xAxis: {
						type: 'category',
						axisLabel: {
							interval:0, //强制显示文字
						},
						data: nameList
					},
					series: series
				};
				
				// set option
				this.myChart.setOption(this.option);
			},// initChart
			// ======================================== 工时统计 chart start ========================================
			
		},// methods
	}// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_pages/Approach/ApproachStatistics.vue